/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// unique contents
import Splash from 'components/content/splash/splash_container';
import Mixed from 'components/content/mixed/mixed_container';
import OutOfContent from 'components/content/outofcontent/outofcontent_container';
import QuestionnaireContent from 'components/content/questionnaire/questionnaire_container'
import UserDataCollection from 'components/content/userdatacollection/userdatacollection_container';
import Ad from 'components/content/ad/ad_container';
import { trackEvent } from 'utils/tracking/tracking';
import { preloadDataImages } from 'utils/preloader';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/content_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});


/* ========== ~~~~~~~~~~ CONTENT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Content extends Component {

	/* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
	constructor(props) {
		super(props);
        sheet.update(props.rewardsEnabled && props.rewardsPermitted);
	}
	componentWillReceiveProps(nextProps, nextContext) {
        this.handleImgPreload(nextProps);
        this.adjustStylesForRewards(nextProps);
        if(!this.props.isActive && nextProps.isActive) {
            this.handleContentInjection(nextProps);
        }
        // active content
		if (!this.isActiveWithFrames(this.props) && this.isActiveWithFrames(nextProps)) {
            this.handleContentInjection(nextProps)
            // ::: tracking: content loaded ::: //
		}
		// inactive content (skip the check for injection conditions) (out of frames)
		if (this.isActiveWithFrames(this.props) && !this.isActiveWithFrames(nextProps)) {
			this.handleContentsInjectablesDeactivation(nextProps);
		}
        // content will not be active on nextProps
        else if (!this.isActiveWithFrames(this.props) || !this.isActiveWithFrames(nextProps)) {
            return null;
        }
        // default
        else {
	        this.handleContentInjection(nextProps); // Check and inject "injectable" Content
			this.handleContentRemoval(nextProps); // kill or deactivate content based on frame count
			this.handleRemainingContentInjection(nextProps)
		}

	}

	/* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */

	handleContentInjection(nextProps) {
		let nextFrame = nextProps.frame;
        let injectablesAtNextFrame = this.props.injectablesAtFrame[nextFrame];
		this.props.injectables.forEach(injectable => {
            let isTargetFrame = injectable.repeatEveryXFrames ? nextFrame >= injectable.injectAtFrame && (nextFrame - injectable.injectAtFrame) % injectable.repeatEveryXFrames === 0 : nextFrame === injectable.injectAtFrame;
            // Checking whether or not the Content was already injected is necessary because the activation of the
			// Injected Content will trigger componentWillReceiveProps to run again with the same nextFrame value.
			if(isTargetFrame && (!injectablesAtNextFrame || (injectablesAtNextFrame && !injectablesAtNextFrame.includes(injectable.id)))) {
				this.activateInjectable(injectable);
			}
		});
	}
    handleRemainingContentInjection = (nextProps) => {
        let nextFrame = nextProps.frame;
        let injectablesAtNextFrame = this.props.injectablesAtFrame[this.props.frame];
        let totalFrameCount = this.props.currentContentStatus.totalFrameCount;
        this.props.injectables.forEach(injectable => {
        	const type = this.props.contentStatus[injectable.id].type;
            let isRemainingInjectable = type === 'userDataCollection' && nextFrame >= totalFrameCount && injectable.injectAtFrame > totalFrameCount;
            if(isRemainingInjectable && (!injectablesAtNextFrame || (injectablesAtNextFrame && !injectablesAtNextFrame.includes(injectable.id)))) {
                this.activateInjectable(injectable);
            }
        });
    }
    activateInjectable(injectable) {
		// console.log('activateInjectable', injectable.id)
    	this.props.injectContent(this.props.contentId, injectable.id);
    }
	handleContentRemoval(nextProps) {
		if(nextProps.frame >= nextProps.currentContentStatus['totalFrameCount']) {
			this.props.deactivateContents([this.props.contentId]);
		}
	}
	handleContentsInjectablesDeactivation(nextProps) {
		if (this.props.killInjectablesOnCompletion) {
			let nestedInjectables = this.getNestedInjectables(nextProps, this.props.contentId);
			console.log('nestedInjectables.contents',nestedInjectables.contents)
		}
	}
	getNestedInjectables(props = this.props, contentId) {
		let contentInjectables = props.contentStatus[contentId].injectedContentIds;
		if (contentInjectables.length === 0) { return { contents: [], parents: {} };}

		let nestedInjectables = { contents: [], parents: {} };
		for (let injectableContentId of contentInjectables) {
			const currentInjectableInjectables = this.getNestedInjectables(props, injectableContentId);
			nestedInjectables = {
				contents: nestedInjectables.contents.concat(currentInjectableInjectables.contents),
				parents: Object.assign({}, nestedInjectables.parents, currentInjectableInjectables.parents)
			}
		}
		return {
			contents: nestedInjectables.contents.concat(contentInjectables),
			parents: nestedInjectables.parents
		};
	}

	handleImgPreload(nextProps) {
        const queue = this.props.queue;
        const curQueuePosition = this.props.queuePosition;
        const nextContent = (curQueuePosition !== null && curQueuePosition + 1 < queue.length) ? queue[curQueuePosition + 1] : null;
        let nextContentData = nextContent ? this.props.contentData[nextContent].data : [];
        nextContentData = nextContentData.length > 1 ? [nextContentData[0]] : nextContentData;
        const nextFrame = this.props.frame + 1;
        // const totalFrameCount = this.props.currentContentStatus.totalFrameCount;
        if (!this.props.isActive && nextProps.isActive) {
            if (nextContent && this.props.currentContentStatus.totalFrameCount === 1) {
                preloadDataImages(nextContentData);
            } else if (nextContent && this.props.currentContentStatus.totalFrameCount > 1 &&
						this.props.currentContentData.data.length > nextFrame) {
                preloadDataImages([this.props.currentContentData.data[nextFrame]]);
			}
		} else if (nextProps.frame === nextFrame &&
            		this.props.currentContentData.data.length > nextFrame + 1) {
            preloadDataImages([this.props.currentContentData.data[nextFrame + 1]]);
		} else if (nextContent && nextProps.frame > this.props.currentContentStatus.totalFrameCount) {
            preloadDataImages(nextContentData);
		}
    }

	isOutOfFrames(props=this.props) {
    	if(props.currentContentStatus['totalFrameCount'] === null) { return false; }
        return props.frame >= props.currentContentStatus['totalFrameCount'];
	}

	isInjectableContent() {
        return this.props.queuePosition === null;
	}
	getDisplayType() {
		return this.isInjectableContent() ? this.props.currentContentSettings.injectedWithSettings.displayType : 'block';
	}
	isActiveWithFrames(props = this.props) {
		return props.isActive && !this.isOutOfFrames();
	}
	displayUniqueContent() {
		switch (this.props.currentContentStatus['type']) {
			case 'mixed':
				return <Mixed contentId={this.props.contentId} handleRemainingContentInjection={this.handleRemainingContentInjection}/>;
			case 'splash':
				return <Splash contentId={this.props.contentId}/>;
      case 'ad':
				return <Ad contentId={this.props.contentId}/>;
			case 'questionnaire':
				return <QuestionnaireContent contentId={this.props.contentId}/>;
			case 'userDataCollection':
				return <UserDataCollection contentId={this.props.contentId}/>;
			default:
				return <OutOfContent contentId={this.props.contentId}/>;
		}
	}
    adjustStylesForRewards(nextProps) {
        if (this.props.rewardsEnabled && this.props.rewardsPermitted !== nextProps.rewardsPermitted) {
            sheet.update(nextProps.rewardsPermitted)
        }
    }
	/* /////////////// RENDER \\\\\\\\\\\\\\\ */
	render() {
		return(
			<div className={`${sheet.classes.content} content ${this.props.currentContentStatus['type']} ${this.getDisplayType()} ${this.isActiveWithFrames() ? 'active' : 'inactive'}`}>
				<div className={`${sheet.classes.inner}`}>
					{this.displayUniqueContent()}
		        </div>
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Content;
